import { gql } from "@apollo/client";
export default gql`
  mutation RefetchCognitoToken($input: RefetchTokenInput!) {
    refetchCognitoToken(input: $input) {
      id_token
      access_token
      refresh_token
      loginResult {
        actionWorkflowEnabled
        allowAllPatients
        clinicalTrial
        dcfWorkflowEnabled
        defaultWardCode
        email
        expired
        hospid
        hospitalAdmin
        hospitalReport
        hospitalReportList
        lastlogin
        id
        mobileNumber
        name
        notificationEmail
        providers
        repeatAtomicComment
        restrictedClinicalStatuses
        resultNotification
        sharedaccount
        showDeletedResults
        smscEnabled
        state
        userId
        username
        hidePanel
        autoSearch
        wards {
          code
          hospid
          id
          name
        }
      }
    }
  }
`;
